import pagination from '../../utils/pagination'
import {
  CUSTOMERS_BATCH_DELETE_REQUEST, CUSTOMERS_BATCH_DELETE_SUCCESS, CUSTOMERS_BATCH_DELETE_FAILURE,
  CUSTOMERS_FETCH_MANY_REQUEST, CUSTOMERS_FETCH_MANY_SUCCESS, CUSTOMERS_FETCH_MANY_FAILURE,
  CUSTOMERS_FETCH_REQUEST, CUSTOMERS_FETCH_SUCCESS, CUSTOMERS_FETCH_FAILURE,
  CUSTOMERS_SAVE_REQUEST, CUSTOMERS_SAVE_SUCCESS, CUSTOMERS_SAVE_FAILURE,
  EMPTY_CUSTOMERS,
  CLEAR_ERRORS
} from './types'

export default {
  [CUSTOMERS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [CUSTOMERS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [CUSTOMERS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [CUSTOMERS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [CUSTOMERS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [CUSTOMERS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [CUSTOMERS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [CUSTOMERS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [CUSTOMERS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [CUSTOMERS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [CUSTOMERS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [CUSTOMERS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_CUSTOMERS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  }
}
